import styled from "styled-components";

export const Image = styled.img`
  object-fit: cover;
  min-width: 54px;
  max-width: 54px;
`;
